import React from 'react';
import './Navbar.css';

const Navbar = ({ isDark, toggleTheme }) => {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className='nav-principal'>
      <div className='nav-contenido'>

        {/* Logo / Prompt */}
        <a
          className='nav-logo'
          href="#home"
          onClick={(e) => handleScroll(e, 'home')}
        >
          <span className='logo-prompt'>~/</span>
          <span className='logo-name'>javif</span>
          <span className='logo-cursor'>█</span>
        </a>

        {/* Menu */}
        <ul className='nav-links'>
          <li>
            <a className='menu-item' href="#home" onClick={(e) => handleScroll(e, 'home')}>
              <span className='menu-prefix'>$</span> home
            </a>
          </li>
          <li>
            <a className='menu-item' href="#skills" onClick={(e) => handleScroll(e, 'skills')}>
              <span className='menu-prefix'>$</span> skills
            </a>
          </li>
          <li>
            <a className='menu-item' href="#experience" onClick={(e) => handleScroll(e, 'experience')}>
              <span className='menu-prefix'>$</span> experience
            </a>
          </li>
          <li>
            <a className='menu-item' href="#projects" onClick={(e) => handleScroll(e, 'projects')}>
              <span className='menu-prefix'>$</span> projects
            </a>
          </li>
          <li>
            <a className='menu-item' href="#contact" onClick={(e) => handleScroll(e, 'contact')}>
              <span className='menu-prefix'>$</span> contact
            </a>
          </li>
        </ul>

        {/* Theme Toggle */}
        <button
          className={`theme-toggle ${isDark ? 'dark' : 'light'}`}
          onClick={toggleTheme}
          aria-label="Toggle theme"
          id="theme-toggle-btn"
        >
          <span className='toggle-icon'>{isDark ? '☀' : '🌙'}</span>
          <span className='toggle-label'>{isDark ? 'light' : 'dark'}</span>
        </button>

      </div>
    </nav>
  );
};

export default Navbar;